import classnames from 'classnames';
import I18n from 'i18n-js';
import React, { useContext } from 'react';
import { withRouter, WithRouterProps } from 'react-router';

import { RCButton } from '@reverbdotcom/cadence/components';

import { SellFormContext } from '../SellFormContext';
import { SellFormPublish } from './SellFormPublish';

export enum ButtonType {
  CONTINUE = 'continue',
  PREVIOUS_SECTION = 'previousSection',
  PUBLISH = 'publish',
  DISCARD = 'discard',
}

interface IExternalProps {
  buttons: ButtonType[];
  disableSubmit: boolean;
  mobileVerticalAlign?: boolean;
  onPreviousButtonClick: () => void;
  onDiscardButtonClick: () => void;
}

function continueButtonText(isDraft, listingState) {
  if (isDraft) {
    return I18n.t('discovery.sellForm.section.continue.draft');
  }

  if (['live', 'sold_out'].includes(listingState)) {
    return I18n.t('discovery.sellForm.section.continue.live');
  }

  return I18n.t('discovery.sellForm.section.continue.saveChanges');
}

function SellFormSectionButtons({
  buttons,
  onPreviousButtonClick,
  onDiscardButtonClick,
  disableSubmit = false,
  mobileVerticalAlign = false,
}: IExternalProps & WithRouterProps) {
  const {
    loading,
    isDraft,
    sellFormViewData,
  } = useContext(SellFormContext);

  const listingState = sellFormViewData?.fetchedListing?.state;

  if (buttons.length < 1) { return null; }
  const classes = classnames('sell-form-section-buttons', {
    'sell-form-section-buttons--submit-disabled': loading || disableSubmit,
    'sell-form-section-buttons--mobile-vertical-align': mobileVerticalAlign,
  });

  return (
    <div className={classes}>
      {buttons.includes(ButtonType.PREVIOUS_SECTION) && (
        <RCButton
          variant="secondary"
          disabled={loading}
          onClick={(e) => {
            e.preventDefault();
            onPreviousButtonClick();
          }}
        >
          {I18n.t('discovery.sellForm.section.back')}
        </RCButton>
      )}

      {buttons.includes(ButtonType.DISCARD) && (
        <RCButton
          aria-disabled={loading}
          variant="secondary"
          onClick={(e) => {
            e.preventDefault();
            onDiscardButtonClick();
          }}
        >
          {I18n.t('discovery.sellForm.section.discard')}
        </RCButton>
      )}

      {buttons.includes(ButtonType.PUBLISH) && <SellFormPublish disabled={loading || disableSubmit}/>}

      {buttons.includes(ButtonType.CONTINUE) && (
        <RCButton
          aria-disabled={loading || disableSubmit}
          variant="primary"
          isSubmit
        >
          {continueButtonText(isDraft, listingState)}
        </RCButton>
      )}
    </div>
  );
}

export default withRouter(SellFormSectionButtons);
